import {
    BrowserRouter,
    Routes,
    Route,
    Navigate,
    useNavigate,
    useLocation,
} from 'react-router-dom';

import { history } from './_helpers';
import { Nav, Alert, PrivateRoute } from './_components';
import { Home } from './pages/home';
import { AccountLayout } from './pages/layout';
import { KbaAuthentication } from './pages/kbaAuthentication';
import { MyProfile } from './pages/MyProfile';
import './App.css';
import '@splidejs/react-splide/css/skyblue';

function App() {
    history.navigate = useNavigate();
    history.location = useLocation();
    const pathName = useLocation().pathname;

    return (
        <>
            {pathName === '/kba' || pathName === '/edit-profile' ? (
                <>
                    <Routes>
                        <Route path='/kba' element={<KbaAuthentication />} />
                        <Route path='/edit-profile' element={<MyProfile />} />
                    </Routes>
                </>
            ) : (
                <div className='app-container bg-light'>
                    <Nav />
                    <Alert />
                    <div className='container pt-4 pb-4'>
                        <Routes>
                            {/* private */}
                            <Route element={<PrivateRoute />}>
                                <Route path='/' element={<Home />} />
                            </Route>
                            {/* public */}
                            <Route path='/*' element={<AccountLayout />} />
                            <Route path='*' element={<Navigate to='/' />} />
                        </Routes>
                    </div>
                </div>
            )}
        </>
    );
}

export default App;
